const CHUNK_LOAD_MARKERS = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Loading chunk",
  "Loading CSS chunk"
]

// API rejections carry the backend envelope, whose `message` is an object, so a
// bare `message?.includes(...)` throws inside the global handler and buries the
// original rejection.
export const isChunkLoadError = (value: unknown): boolean => {
  const message = (value as { message?: unknown } | null | undefined)?.message

  if (typeof message !== "string") {
    return false
  }

  return CHUNK_LOAD_MARKERS.some((marker) => message.includes(marker))
}
